import { useTranslation } from 'react-i18next';
import { Calculator, CircleHelp, Clock3 } from 'lucide-react';
import { useLocale } from '@/hooks/useLocale';

// Editorial illustration only. Not a live estimate, fixture, market average or model output.
const BREAKDOWN = [['internal', 42100, 'carbon'], ['consulting', 28500, 'grey'], ['audit', 14200, 'blue'], ['tools', 9900, 'light']];
export const ProductPreview = () => {
  const { t } = useTranslation();
  const { lang } = useLocale();
  const money = value => new Intl.NumberFormat(lang, { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(value);
  return <section className="lp-proof" data-testid="landing-product-proof" aria-labelledby="landing-preview-title">
    <div className="lp-container">
      <div className="lp-section-header">
        <h2 id="landing-preview-title" data-testid="landing-preview-title">{t('homepage.preview.heading')}</h2>
        <span className="lp-example-label" data-testid="landing-preview-label">{t('homepage.exampleLabel')}</span>
      </div>
      <figure className="lp-result-preview" data-testid="landing-result-preview" aria-describedby="landing-preview-caption">
        <div className="lp-preview-toolbar" data-testid="landing-preview-toolbar">
          <span className="lp-preview-brand"><Calculator size={17} aria-hidden="true" />ISMSCalculator</span>
          <span>{t('homepage.preview.workspace')}</span>
        </div>
        <div className="lp-preview-body">
          <div className="lp-preview-headline">
            <p className="lp-label" data-testid="landing-investment-label">{t('homepage.preview.investment')}</p>
            <p className="lp-estimate-value" data-testid="landing-preview-investment">{money(94700)}</p>
            <dl>
              <dt>{t('homepage.preview.range')}</dt>
              <dd className="lp-range" data-testid="landing-preview-range">{money(75000)} – {money(118000)}</dd>
            </dl>
            <div className="lp-preview-metrics">
              <dl><dt><Clock3 size={14} aria-hidden="true" />{t('homepage.preview.timeline')}</dt>
                <dd data-testid="landing-preview-timeline">9–11 {t('homepage.months')}</dd></dl>
              <dl><dt><CircleHelp size={14} aria-hidden="true" />{t('homepage.preview.confidence')}</dt>
                <dd data-testid="landing-preview-confidence">{t('homepage.preview.moderate')}</dd></dl>
            </div>
          </div>
          <div className="lp-preview-breakdown">
            <h3 data-testid="landing-breakdown-title">{t('homepage.preview.breakdown')}</h3>
            <div className="lp-stacked-bar" aria-hidden="true">
              {BREAKDOWN.map(([key, value, color]) => <span key={key} className={`lp-swatch-${color}`} style={{ flex: value }} />)}
            </div>
            <dl className="lp-breakdown-rows" x-excluded="true">
              {BREAKDOWN.map(([key, value, color]) => <div key={key} className="lp-breakdown-row" data-testid={`landing-breakdown-${key}`}>
                <dt><span className={`lp-swatch lp-swatch-${color}`} aria-hidden="true" />{t(`homepage.preview.${key}`)}</dt>
                <dd>{money(value)}</dd>
              </div>)}
            </dl>
          </div>
        </div>
        <figcaption id="landing-preview-caption" data-testid="landing-preview-caption">{t('homepage.preview.caption')}</figcaption>
      </figure>
    </div>
  </section>;
};